/**
 * Carte de relance en pied de bilan (réutilisabilité — Étape 5).
 * Présentation pure : le contenu (question, texte, couleur, actions) vient de la
 * règle administrable choisie par le moteur. 1 principale + 1 secondaire + sortie.
 */
import { useTranslation } from "react-i18next";
import { Button } from "./ui/button";
import type { RelanceCardData } from "../lib/api";

const COLOR_MAP: Record<string, string> = {
  navy: "#384872",
  violet: "#8B7CC4",
  green: "#7CBF94",
  coral: "#E8836B",
  gold: "#F2C94C",
};
function resolveColor(c: string): string {
  return c.startsWith("#") ? c : COLOR_MAP[c] || "#384872";
}

export function RelanceCard({
  card,
  lang,
  busy,
  onPrimary,
  onSecondary,
  onDismiss,
}: {
  card: RelanceCardData;
  lang: string;
  busy?: boolean;
  onPrimary: () => void;
  onSecondary: () => void;
  onDismiss: () => void;
}) {
  const { t } = useTranslation();
  const en = lang === "en";
  const question = en ? card.primary.questionEn : card.primary.questionFr;
  const button = en ? card.primary.buttonEn : card.primary.buttonFr;
  const color = resolveColor(card.primary.color);
  const secText = card.secondary ? (en ? card.secondary.textEn : card.secondary.textFr) : "";

  return (
    <div className="rounded-2xl border bg-white p-5 shadow-sm w-full max-w-md text-left" style={{ borderColor: color }}>
      {question && (
        <p className="font-semibold mb-3" style={{ color: "#384872", fontFamily: "Sora, sans-serif", fontSize: 17 }}>
          {question}
        </p>
      )}
      <Button onClick={onPrimary} disabled={busy} className="w-full text-white" style={{ background: color }}>
        {button}
      </Button>
      {card.secondary && secText && (
        <div className="mt-3">
          <button onClick={onSecondary} disabled={busy} className="text-sm font-medium" style={{ color: "#384872" }}>
            {secText} →
          </button>
        </div>
      )}
      <div className="mt-2">
        <button onClick={onDismiss} disabled={busy} className="text-xs" style={{ color: "#9AA0B0" }}>
          {t("relance.other")}
        </button>
      </div>
    </div>
  );
}
